<template>
<div>
  <list-page
      :columns="columns"
      :headers="headers"
      :popupComponent="popupComponent"
      :basic-data="basicData"
      :show-mail-box-news-letter="true"
      sort="email"
      title="Email List"
      icon="mdi-mailbox"
      addButtonText="Email"
      stateendpoint="mailBox.mailBoxes"
      :show-select="true"
      :actions="actions"
      :action-buttons="actionButton"
  />
</div>
</template>

<script>
import ListPage from "../../components/ListPage";
import MailBoxPopup from "../../components/popups/MailBoxPopup";
import UserMixin from "../../components/mixins/UserMixin";

export default {
  name: "MailBox",
  mixins: [UserMixin],
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Mail Box | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {
    ListPage,
    MailBoxPopup
  },
  data() {
    return {
      headers: [
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'email'},
        {value: 'isActive'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadMailBoxes',
        create: 'storeMailBox',
        update: 'updateMailBox',
        remove: 'destroyMailBox',
        softDelete: 'mailBoxSoftDeleteHandler',
        sendMail: 'sendNewsLetter'
      },
      basicData: {
        isActive: true,
        mailType: 1
      },
      actionButton: [
        {
          category: 'timeLiner',
          icon: 'mdi-eye',
          color: '',
          text: 'View Mail Details',
          clickHandler: 'viewEmailDetails'
        }
      ]
    }
  },
  computed: {
    popupComponent() {
      return MailBoxPopup;
    }
  }
}
</script>

<style scoped>

</style>